import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { KeyValuePipe } from "@angular/common";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { GroupFilterOptions } from "@/_models/filters/group-filter-options";
import { RadioOption } from "@/components/shared/radio-list/radio-list.component";

@Component({
    selector: "app-performance-filter-topbar",
    standalone: true,
    imports: [KeyValuePipe, SharedComponentsModule],
    templateUrl: "./performance-filter-topbar.component.html",
    styleUrls: ["./performance-filter-topbar.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerformanceFilterTopbarComponent {
    @Input() filterForm: UntypedFormGroup;
    @Input() currentFilters;
    @Input() groupFilterOptions: GroupFilterOptions;
    @Input() userList: RadioOption[];
    @Output() filterButtonClicked: EventEmitter<void> =
        new EventEmitter<void>();

    readonly dateRangeChip = { key: "createdAt", value: "" };

    openFilterMenu() {
        this.filterButtonClicked.emit();
    }

    resetFilter(filterKey: string) {
        const emptyValue = filterKey === "groups" ? [] : "";
        return this.filterForm.get(filterKey)?.setValue(emptyValue);
    }
}
